import { getModel } from "@qpr/client-api-base/api/model";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { useQuery } from "react-query";

const useModel = () => {
  const ctx = useAppContext();
  return useQuery(`model-${ctx.model || ""}`, () => getModel(ctx.model || ""), {
    cacheTime: 10 * 60 * 1000,
    staleTime: 10 * 60 * 1000,
  });
};

export default useModel;
